module.exports = __webpack_public_path__ + "media/images/color_admin_v3/product/product-3-a769692d6313f30b635b5b3e1f7abd0b.png";